export default "__VITE_ASSET__aDZ5rePb__"